
import autoComplete from "@tarekraafat/autocomplete.js";
import { http } from './../utility/http.js'


function search({ url, query = {} }) {
	return new Promise((resolve, reject) => {
		http({
			url: `${url}?${(new URLSearchParams(query)).toString()}`,
			success: response => {
				resolve(JSON.parse(response))
			}
		})
	})
}

function autocomplete(selector, data) {

	const el = document.querySelector(selector)
	if (!el) return

	// on return: submit form, but only when not selecting listitem
	el.addEventListener('keydown', event => {
		if (event.keyCode !== 13) return
		const hasSelected = !!instance.feedback?.selection
		if (hasSelected && instance.isOpen) return
		event.currentTarget.form.submit()
	})

	const instance = new autoComplete({
		selector: selector,
		debounce: 100,
		data: {
			cache: false,
			...data,		    
		},
		submit: false,
		wrapper: false,
		resultItem: { 
			highlight: true,
			class: "autocomplete-result",
			highlight: "autocomplete-highlight",
			selected: "autocomplete-selected"
		},
		resultsList: {
		    maxResults: 15,
		    tabSelect: true,
		    class: "autocomplete-list",
		    position: "afterend",
		},
		events: {
			input: {
				focus: event => {
					event.currentTarget.value.length && instance.start()
				},
				selection: event => {
					event.currentTarget.value = event.detail.selection.value[event.detail.selection.key]
				}
			}
		}
	})

	return instance
}

export default function init() {

	const domain = document.querySelector('.js-autocomplete-domain')?.value

	const term = autocomplete('.js-autocomplete-term', {
		src: async term => search({
			url: `/api/suggest`,
			query: { term, dictionary: 'job_search', domain: domain },
		}),
		keys: ['term']
	})

	const location = autocomplete('.js-autocomplete-location', {
		src: async term => search({
			url: `/api/suggest`,
			query: { term, dictionary: 'location', domain: domain },
		}),
		keys: ['term']
	})
}